<template>
  <div class="products-hgys-page-content flex flex-col items-center w-full text-left">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem max-ml:w-100% max-ml:object-cover max-ml:object-center"
        :src="content.banner" alt="" />
      <PageContentCenter class="text-[#616671] absolute top-[10.3rem]">
        <h2 class="text-2.63rem text-[#102136] mb-[32px] font-semibold">
          {{ title }}
        </h2>
        <p class="">{{ description }}</p>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/hgys.png"></Pic>
    </section>

    <section class="relative w-full text-center">
      <PageContentCenter class="text-[#616671] text-[16px] relative mt-6rem">
        <div class="relative flex justify-between text-left align-center">
          <div class="relative w-31rem max-ml:w-100%">
            <h3 class="relative  mb-18.24px hgys-business-introduction-title">
              <span class="relative text-2rem z-2 ">{{ content.businessIntroduction.title }}</span>
            </h3>

            <ul class="features-group-ul inline-block">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[16px] mb-[18.08px] features-group-li inline-block">{{ desc
                }}
              </li>
            </ul>
          </div>
          <Pic :src="content.businessIntroduction.mainImage" class="w-40rem self-center max-ml:hidden "></Pic>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">
      <h2 class="text-[32px] text-[#272E3B] pt-[5rem] font-bold text-center bg-#F6F8FD">
        <PageContentCenter>
          {{ content.featuresIntroduction.title }}
        </PageContentCenter>
      </h2>

      <section :class="['flex', 'py-56.96px', group.direction === 'copywriting-to-image' ? 'bg-[#F6F8FD]' : '']"
        v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-350px relative  align-self-center max-ml:w-100%">
            <div :class="['mb-28px']">
              <h4 class="text-30.08px">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul">
              <li v-for="desc in group.descList"
                class="text-[#616671] text-[16px] mb-[32px] features-group-li  leading-2rem">{{
                  desc
                }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.5rem max-ml:w-100%" :src="group.mainImage" :style="{}"></Pic>

        </PageContentCenter>
      </section>
    </section>

    <section
      class="relative w-full hgys-product-advantage bg-#E7ECF8 h-52rem max-ml:overflow-x-hidden   max-ml:h-[auto] ">
      <PageContentCenter class="text-[#272E3B] relative max-ml:w-100%">
        <h2 class="text-2.63rem text-[#272E3B] pt-[5rem] text-center mb-2.5rem font-semibold">
          {{ content.advantage.title }}
        </h2>
        <ul class="flex justify-center gap-39.04px  max-ml:flex-col max-ml:items-center max-ml:gap-0px">
          <li v-for="item in content.advantage.list"
            class="hgys-product-advantage-item relative max-ml:w-100% max-ml:mb-20px max-ml:px-1rem">
            <Pic :src="item.mainImage" class="relative w-24.25rem h-30rem max-ml:w-100%"></Pic>
          </li>
        </ul>
      </PageContentCenter>
    </section>

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { useSeoMeta } from 'nuxt/app'
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
const title = '和贵云商'
const description = '政企福利定制&行业方案'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  banner: '/images/pages/products/hgys/hgys-b.png',
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '和贵科技研发的专业外勤管理软件，深度适配物流、零售、建筑、服务等多个行业场景，致力于帮助企业重塑外勤管理模式',
    desc: '',
    mainImage: '/images/pages/products/hgys/Frame 2147229841@2x.png',
    descList: [
      '和贵云商，是由和贵科技研发的福利商城。我们专注于为企业提供一站式的员工节假日福利解决方案，支持专属定制与高效发放。',
      '平台积极响应国家乡村振兴政策，严选优质助农特产，将原生态的健康产品直达企业员工，让福利发放更具社会意义。'
    ],
  },
  featuresIntroduction: {
    title: '产品功能',
    desc: '',
    groups: [
      {
        title: '商家管理',
        desc: '',
        descList: [
          '实现对入驻供应商的资质审核、合同及生命周期管理，确保货源可靠。',
        ],
        mainImage: '/images/pages/products/hgys/Frame 2147229842@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '商品管理',
        desc: '',
        descList: ['全流程管理助农特产等福利商品，支持专属定制与灵活上下架操作。',],
        mainImage: '/images/pages/products/hgys/Frame 2147229843@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '营销管理',
        desc: '',
        descList: ['配置专属福利活动与优惠，激发员工领取意愿，提升福利满意度。'],
        icon: '/images/pages/products/hgys/Frame 2147229478@2x.png',
        mainImage: '/images/pages/products/hgys/Frame 2147229844@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '订单管理',
        desc: '',
        descList: ['跟踪福利订单从生成到履约的全流程，状态清晰，处理高效。',],
        icon: '/images/pages/products/hgys/Frame 2147229636@2x(1).png',
        mainImage: '/images/pages/products/hgys/Frame 2147229845@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '库存管理',
        desc: '',
        descList: ['实时监控商品库存，设置预警机制，保障福利发放的稳定性。'],
        icon: '/images/pages/products/hgys/Frame 2147229480@2x.png',
        mainImage: '/images/pages/products/hgys/Frame 2147229846@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '财务管理',
        desc: '',
        descList: ['清晰管理平台交易流水与结算对账，让资金往来一目了然。'],
        mainImage: '/images/pages/products/hgys/Frame 2147229480@2x.png',
        direction: 'image-to-copywriting'
      }, {
        title: '企业管理',
        desc: '',
        descList: ['核心模块，统一配置企业福利方案、管理发放范围周期及员工信息。',],
        mainImage: '/images/pages/products/hgys/Frame 2147229847@2x.png',
        direction: 'copywriting-to-image'
      }, {
        title: '客服管理',
        desc: '',
        descList: ['为企业与员工提供全渠道、多场景的咨询与售后服务，确保福利发放全程无忧。'],
        mainImage: '/images/pages/products/hgys/Frame 2147229850@2x.png',
        direction: 'image-to-copywriting'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '专属定制  高效便捷',
        desc: '支持企业个性化定制福利方案，平台实现高效发放与全程管理，极大减轻企业行政负担。',
        mainImage: '/images/pages/products/hgys/Group 1171274998@2x.png',
      },
      {
        title: '助农优品  福利增值',
        desc: '严选原生态助农特产，福利品质与健康双重保障，同时赋能企业践行社会责任，提升福利内涵。',
        mainImage: '/images/pages/products/hgys/Group 1171274999@2x.png',
      },
      {
        title: '政策响应  意义深远',
        desc: '积极响应国家乡村振兴号召，将员工福利与社会贡献相结合，彰显企业卓越的品牌形象。',
        mainImage: '/images/pages/products/hgys/Group 1171275000@2x.png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-hgys-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .hgys-product-advantage-item {
    width: 24.25rem;
    height: 30rem;
  }
}

.accordion-container {
  display: flex;
  height: 18.75rem;
  gap: 16px;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
